<template>
  <div class="agent-trade-role">
    <div class="section">
      <div class="filter-wrapper">
        <span>{{ $t("proxy.text41") }}：</span>
        <el-input
          clearable
          v-model="roleName"
          style="width: 220px"
          placeholder=""
        />
        <span class="ml-40">{{ $t("followOrder.text71") }}：</span>
        <el-select
          v-model="statusFilter"
          placeholder=""
          size="large"
          style="width: 240px"
        >
          <el-option :label="$t('proxy.text95')" value="0" />
          <el-option :label="$t('proxy.text198')" value="1" />
          <el-option :label="$t('proxy.text199')" value="2" />
        </el-select>
        <el-button class="ml-40" type="primary" @click="handleSearch">{{
          $t("proxy.text13")
        }}</el-button>
      </div>
      <div class="data-wrapper mt-20">
        <el-table
          :data="filteredData"
          header-row-class-name="data-header"
          header-cell-class-name="data-header-cell"
          style="width: 100%"
        >
          <el-table-column
            prop="rulesGroupID"
            :label="$t('proxy.text247')"
            width="180"
            align="center"
          />
          <el-table-column
            prop="rulesGroupLevelName"
            :label="$t('fundHistory.text48')"
            width="200"
            align="center"
          />
          <el-table-column
            prop="rulesGroupName"
            :label="$t('proxy.text41')"
            width="300"
            align="center"
          />
          <el-table-column
            prop="statusStr"
            :label="$t('proxy.text248')"
            width="150"
            align="center"
          />

          <el-table-column
            :label="$t('proxy.text139')"
            :width="canAddSubProxy ? 600 : 300"
            align="center"
            fixed="right"
          >
            <template #default="scope">
              <el-button
                v-if="canAddSubProxy"
                link
                type="primary"
                @click="addSubRule(scope.row)"
                >{{ $t("proxy.text249") }}</el-button
              >
              <el-button
                v-if="canAddSubProxy"
                link
                type="primary"
                @click="viewSubRule(scope.row)"
                class="green-button"
                >{{ $t("proxy.text250") }}</el-button
              >
              <el-button
                link
                type="primary"
                @click="viewCurrentRule(scope.row)"
                class="blue-button"
                >{{ $t("proxy.text311") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalEntries"
          :page-sizes="[10, 50, 100, 200]"
          :disabled="false"
          :background="true"
          layout="total, prev, pager, next, sizes"
          class="pagination-container mt-20"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import apiService from "@/api/request"; // 假设API服务文件在此路径
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const router = useRouter();
    const roleData = ref([]);
    const filteredData = ref([]);
    const roleName = ref("");
    const statusFilter = ref("0"); // 默认值为全部
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalEntries = ref(0);
    const t = useI18n().t;
    const canAddSubProxy = ref(false); // 是否可以添加子代理数据（控制“添加下级规则组、查看下级规则组”两个按钮的显示/隐藏）

    // 获取用户信息，判断是否可以添加代理
    const fetchUserInformation = async () => {
      try {
        const response = await apiService.UserInformation(); // 请求接口获取用户信息
        if (response.status === 1) {
          canAddSubProxy.value = response.data.canAddSubProxy; // 设置 canAddSubProxy 字段
        } else {
          ElMessage.error(response.message); // 处理接口失败
        }
      } catch (error) {
        console.error(error);
      }
    };

    const fetchRoleData = async () => {
      try {
        const params = {
          page: currentPage.value,
          limit: pageSize.value,
          name: roleName.value,
          status: statusFilter.value,
        };
        const response = await apiService.proxyRulesGroupList(params);
        if (response.status === 1) {
          roleData.value = response.data.list;
          totalEntries.value = response.data.count;
          filterData(); // 调用过滤函数
        } else {
          ElMessage.error(t("proxy.text251"));
        }
      } catch (error) {
        ElMessage.error(t("proxy.text251"));
        console.error("获取规则组数据失败", error);
      }
    };

    const filterData = () => {
      filteredData.value = roleData.value.filter((item) => {
        const matchesName =
          roleName.value === "" || item.rulesGroupName.includes(roleName.value);
        const matchesStatus =
          statusFilter.value === "0" ||
          (statusFilter.value === "1" && item.status === 1) ||
          (statusFilter.value === "2" && item.status === 2);
        return matchesName && matchesStatus;
      });
    };

    const addSubRule = (row) => {
      router.push({
        name: "agentTradeRoleEdit",
        query: { parentId: row.rulesGroupID, activeMenu: "traderole" },
      });
    };

    // 编辑操作
    const viewSubRule = (row) => {
      router.push({
        name: "agentTradeSubGroupRole",
        query: {
          rulesGroupID: row.rulesGroupID,
          rulesGroupName: row.rulesGroupName,
          activeMenu: "traderole",
        },
      });
    };

    // 查看当前规则
    const viewCurrentRule = (row) => {
      router.push({
        name: "agentTradeRoleCheck",
        query: {
          rulesGroupID: row.rulesGroupID,
          rulesGroupName: row.rulesGroupName,
          activeMenu: "traderole",
        },
      });
    };

    const handlePageChange = (page) => {
      currentPage.value = page;
      fetchRoleData();
    };

    const handleSizeChange = (size) => {
      pageSize.value = size;
      fetchRoleData();
    };

    const handleSearch = () => {
      currentPage.value = 1;
      fetchRoleData();
    };

    onMounted(() => {
      fetchUserInformation();
      fetchRoleData();
    });

    return {
      roleData,
      filteredData,
      roleName,
      statusFilter,
      fetchRoleData,
      handleSearch,
      addSubRule,
      viewSubRule,
      viewCurrentRule,
      currentPage,
      pageSize,
      totalEntries,
      handlePageChange,
      handleSizeChange,
      t,
      canAddSubProxy,
    };
  },
};
</script>

<style scoped>
.el-button {
  font-size: 16px !important;
}

.filter-wrapper {
  padding: 20px 0;
}

.pagination-container {
  display: flex;
  justify-content: flex-center;
}

.green-button {
  color: #0d9172 !important;
}

.blue-button {
  color: #3553ee !important;
}
</style>
